import Vue from 'vue'
import VueRouter from 'vue-router'
import category from "@/modules/category/router/category";
import auth from "@/modules/auth/router/auth";
import home from "@/modules/home/router/home";
import order from "@/modules/order/router/order";
import product from "@/modules/product/router/product";
import menu from "@/modules/menu/router/menu";
import customer from "@/modules/client/router/client";
import outlet from "@/modules/outlets/router/outlets";
import user from "@/modules/user/router/user";


const routes = [
  ...home, ...auth, ...category, ...product, ...menu, ...order, ...customer, ...outlet,...user,
  {
    path: '/restricted',
    name: 'access-denied',
    component: () => import('../views/Error403.vue'),
    meta: {
      title: 'Page Accès refusé',
      layout: 'default',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('../views/Error.vue'),
    meta: {
      title: 'Page Not Found',
      layout: 'no-footer',
    }
  }
]

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
import authentification from "@/modules/auth/services/auth";

// Auth admin
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (authentification.isLoggedIn()) {
      if(to.matched.some(record => record.meta.authorize)){
        const userInfo = authentification.getUserInfo()
        const found = to.meta.authorize.some(r=> userInfo.roles.includes(r))
        if(found){
          next()
          return
        }
        else {
          next("/dashboard/restricted");
          return;
        }
      }
      next()
      return
    }
    next('/connexion')
  } else {
    if(to.name === 'signin' && from.name === '/'){
      next('/connexion')
    }else{
      next()
    }
  }
})


export default router
